import { render, staticRenderFns } from "./ThermalChart.vue?vue&type=template&id=1a36652a&scoped=true&"
import script from "./ThermalChart.vue?vue&type=script&lang=ts&"
export * from "./ThermalChart.vue?vue&type=script&lang=ts&"
import style0 from "./ThermalChart.vue?vue&type=style&index=0&id=1a36652a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36652a",
  null
  
)

export default component.exports